import {
    WbSunnyOutlined,
    DarkModeOutlined,
    AccountCircleOutlined,
    AssessmentOutlined,
    BadgeOutlined,
    CheckBoxOutlined,
    ContactSupportOutlined,
    DashboardCustomizeOutlined,
    DirectionsCarFilledOutlined,
    ExitToAppOutlined,
    FenceOutlined,
    GroupOutlined,
    PlaceOutlined,
    HailOutlined,
    Help,
    HelpOutlineOutlined,
    LayersOutlined,
    LibraryAddOutlined,
    LogoutOutlined,
    ManageAccountsOutlined,
    MapOutlined,
    MenuOpenOutlined,
    MenuOutlined,
    NotificationsActiveOutlined,
    NotificationsNoneOutlined,
    PersonOutlineOutlined,
    ScheduleOutlined,
    RouteOutlined,
    SearchOutlined,
    SettingsOutlined,
    ShareLocationOutlined,
    TuneOutlined,
    VideoCameraFrontOutlined,
} from "@mui/icons-material";

import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import eventSound from "../../assets/audio/index";

import {
    Fragment,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import {
    Badge,
    Box,
    Divider,
    Drawer,
    IconButton,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    styled,
    Switch,
    SwitchProps,
    Toolbar,
    Tooltip,
    Typography,
} from "@mui/material";
import { Toast } from "primereact/toast";

import "./styles.css";
import SelectParametersModal from "./home/components/SelectParametersModal";
import { useRecoilValue, useSetRecoilState } from "recoil";

import {
    DepartmentSimpleType,
    DriverAlertCustomerSummaryType,
    EventResponse,
    SecretarySimpleType,
    SelectedParametersType,
    UserType,
    VehicleAlertCustomerSummaryType,
    CustomerFeatureType,
} from "../../types/types";
import { useCustomerFeatures } from "../../hooks/useCustomerFeatures";

import { selectedParametersAtom, userAtom } from "../../atoms/atoms";
import { useCookies } from "react-cookie";

import { eventHandlerMessage } from "../../functions/functions";

import dayjs from "dayjs";
import { departmentDefault, MENUS_ITENS, PROFILE_ACESSES, secretaryDefault } from "../../consts/consts";

import DashMapPage from "./home";
import GroupsPage from "./groups";
import GeofencePage from "./geofences";
import InterestPointPage from "./interestPoints";
import DriverPage from "./drivers";
import AccessPage from "./accesses";
import SettingsPage from "./settings";
import ProfilePage from "./profile";
import NotFoundPage from "../publicRoutes/notfound";
import ReportPage from "./reports";
import HelpPage from "./help";
import VehiclePage from "./vehicles";
import WorkSchedulePage from "./workSchedules";
import RoutesPage from "./RoutesPage";

import userFindAllSecretariesListResponse from "../../resources/Api/user/userFindAllSecretariesListResponse";
import userFindAllDepartmentsListResponse from "../../resources/Api/user/userFindAllDepartmentsListResponse";
import logoutUser from "../../resources/Api/authenticator/logoutUser";
import HomePage from "../privateApp/home/dashboard";
import VideoTelemetry from "./videotelemetry";
import findEventByCustomerAndDate from "../../resources/Api/event/findEventByCustomerAndDate";
import findRecentEventsByCustomer from "../../resources/Api/event/findRecentEventsByCustomer";
import findAllVehicleAlerts from "../../resources/Api/vehiclealert/findAllVehicleAlerts";
import findAllDriverAlerts from "../../resources/Api/driveralert/findAllDriverAlerts";
import DriverAlertCard from "../../components/DriverAlertCard";
import VehicleAlertCard from "../../components/VehicleAlertCard";
import TrackingEventAlertCard from "../../components/TrackingEventAlertCard";
import RouteDeviationAlertCard from "../../components/RouteDeviationAlertCard";
import { routeApi, RouteDeviationAlert } from "../../resources/Api/routeApi";
import { useThemeMode } from "../../components/DarkModeWrapper";
import TransparencyPortalLinkButton from "../../components/TransparencyPortalLinkButton";
import { useIntroTour } from "../../components/introTour/useIntroTour";
import { buildIntroTourSteps, menuTourId, tourAnchor } from "../../components/introTour/introTourSteps";

/**
 * PrivateDriverRoutes - Creates private routes do access options
 * @component
 */
const PrivateDriverRoutes = ({
    isHiddenMenu
}: {
    isHiddenMenu: boolean;
}) => {
    return <>
        <Routes>
            <Route path="/" element={<ReportPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/reports" element={<ReportPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/user-profile" element={<ProfilePage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/checklists" element={<HelpPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    </>
};

/**
 * PrivateRoutes - Creates routes do access options
 * @component
 */
const PrivateRoutes = ({
    isHiddenMenu,
    isFixedMenu,
    isMenuOverlayOpen,
    showGeofences,
    showInterestPoints,
    showCarsFilter,
    showMapChanger,
    showMapSearch,
    filterActions,
    customerFeatures,
}: {
    isHiddenMenu: boolean;
    isFixedMenu: boolean;
    isMenuOverlayOpen: boolean;
    showGeofences: boolean;
    showInterestPoints: boolean;
    showCarsFilter: boolean;
    showMapChanger: boolean;
    showMapSearch: boolean;
    filterActions: Array<{ name: string; action: (value: boolean) => void }>;
    customerFeatures: CustomerFeatureType | null;
}) => {
    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={
                        <DashMapPage
                            isHiddenMenu={isHiddenMenu}
                            isFixedMenu={isFixedMenu}
                            isMenuOverlayOpen={isMenuOverlayOpen}
                            showGeofences={showGeofences}
                            showInterestPoints={showInterestPoints}
                            showCarsFilter={showCarsFilter}
                            showMapChanger={showMapChanger}
                            showMapSearch={showMapSearch}
                            actions={filterActions}
                        />
                    }
                />
                <Route path="/dashboard" element={<HomePage />} />
                <Route
                    path="/geofences"
                    element={<GeofencePage isHiddenMenu={isHiddenMenu} />}
                />
                <Route
                    path="/interest-points"
                    element={<InterestPointPage isHiddenMenu={isHiddenMenu} />}
                />
                <Route
                    path="/groups"
                    element={<GroupsPage isHiddenMenu={isHiddenMenu} />}
                />
                <Route
                    path="/drivers"
                    element={<DriverPage isHiddenMenu={isHiddenMenu} />}
                />
                <Route path="/vehicles" element={<VehiclePage isHiddenMenu={isHiddenMenu} />} />
                <Route path="/video-telemetry" element={<VideoTelemetry isHiddenMenu={isHiddenMenu} />} />
                <Route
                    path="/work-schedules"
                    element={customerFeatures?.useWorkSchedules === true ? <WorkSchedulePage isHiddenMenu={isHiddenMenu} /> : <Navigate to="/" replace />}
                />
                <Route path="/routes" element={<RoutesPage isHiddenMenu={isHiddenMenu} allowCalculatedRoutes={customerFeatures?.useCalculatedRoutes === true} />} />
                <Route
                    path="/sub-accesses"
                    element={<AccessPage isHiddenMenu={isHiddenMenu} />}
                />
                <Route
                    path="/system-config"
                    element={<SettingsPage isHiddenMenu={isHiddenMenu} />}
                />
                <Route
                    path="/user-profile"
                    element={<ProfilePage isHiddenMenu={isHiddenMenu} />}
                />
                <Route
                    path="/reports"
                    element={<ReportPage isHiddenMenu={isHiddenMenu} allowCalculatedRoutes={customerFeatures?.useCalculatedRoutes === true} />}
                />
                <Route
                    path="/help"
                    element={<HelpPage isHiddenMenu={isHiddenMenu} />}
                />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </>
    );
};

const sidebarMenus = [
    {
        text: "Geral",
        icon: <LibraryAddOutlined style={{ marginRight: 5 }} />,
        route: "/",
        id: 1,
    },
    {
        text: "Sístema",
        icon: <SettingsOutlined style={{ marginRight: 5 }} />,
        route: "groups",
        id: 2,
    },
];

const sidebarRecordsItems = [
    { text: "Rastreamento", icon: <MapOutlined />, route: "/", id: 1, menuId: 1, tour: "Esta tela: acompanhe a frota no mapa em tempo real." },
    { text: "Painel de indicadores", icon: <DashboardCustomizeOutlined />, route: "/dashboard", id: 20, menuId: 1, tour: "Resumo da frota em gráficos e indicadores." },
    {
        text: "Grupos",
        icon: <GroupOutlined />,
        route: "groups",
        id: 2,
        menuId: 1,
        tour: "Organize os veículos em grupos.",
    },
    {
        text: "Cercas virtuais",
        icon: <FenceOutlined />,
        route: "geofences",
        id: 3,
        menuId: 1,
        tour: "Desenhe áreas no mapa para acompanhar a entrada e a saída dos veículos.",
    },
    {
        text: "Pontos de interesse",
        icon: <PlaceOutlined />,
        route: "interest-points",
        id: 24,
        menuId: 1,
        tour: "Cadastre locais importantes para exibir no mapa.",
    },
    {
        text: "Motoristas",
        icon: <HailOutlined />,
        route: "drivers",
        id: 4,
        menuId: 1,
        tour: "Cadastro dos motoristas e dos seus identificadores.",
    },
    {
        text: "Veículos",
        icon: <DirectionsCarFilledOutlined />,
        route: "vehicles",
        id: 9,
        menuId: 1,
        tour: "Cadastro dos veículos e dos seus parâmetros.",
    },
    {
        text: "Video telemetria",
        icon: <VideoCameraFrontOutlined />,
        route: "video-telemetry",
        id: 21,
        menuId: 1,
        tour: "Câmeras embarcadas nos veículos.",
    },
    {
        text: "Escalas de trabalho",
        icon: <ScheduleOutlined />,
        route: "work-schedules",
        id: 25,
        menuId: 1,
        tour: "Escalas de trabalho dos condutores.",
    },
    {
        text: "Rotas",
        icon: <RouteOutlined />,
        route: "routes",
        id: Number(MENUS_ITENS.ROUTES),
        menuId: 1,
        tour: "Planeje rotas e acompanhe desvios.",
    },
];

const vehicleAlertCustomerSummaryDefault: VehicleAlertCustomerSummaryType = {
    customerId: -1,
    total: 0,
    critical: 0,
    warning: 0,
    vehicles: [],
};

const driverAlertCustomerSummaryDefault: DriverAlertCustomerSummaryType = {
    customerId: -1,
    total: 0,
    critical: 0,
    warning: 0,
    alerts: [],
};

const sidebarConfigsItems = [
    {
        text: "Acessos",
        icon: <BadgeOutlined />,
        route: "sub-accesses",
        id: 13,
        menuId: 2,
        tour: "Usuários e permissões de acesso ao sistema.",
    },
    {
        text: "Configurações",
        icon: <SettingsOutlined />,
        route: "system-config",
        id: 14,
        menuId: 2,
        tour: "Parâmetros do cliente, como eventos, alertas e notificações.",
    },
    {
        text: "Relatórios",
        icon: <AssessmentOutlined />,
        route: "reports",
        id: 15,
        menuId: 2,
        tour: "Relatórios de posições, viagens, eventos e mais.",
    },
    {
        text: "Ferramentas",
        icon: <ContactSupportOutlined />,
        route: "help",
        id: 16,
        menuId: 2,
        tour: "Ferramentas de apoio e chamados de suporte.",
    },
    {
        text: "Checagem",
        icon: <CheckBoxOutlined />,
        route: "checklists",
        id: 22,
        menuId: 2,
    },
];

const footerItems = [
    {
        text: "Perfil",
        icon: <PersonOutlineOutlined />,
        route: "user-profile",
        id: 17,
    },
    { text: "Sair", icon: <LogoutOutlined />, route: "out", id: 18 },
];

const introTourSteps = buildIntroTourSteps("client", [...sidebarRecordsItems, ...sidebarConfigsItems]);

const PrivateApp = () => {
    const {
        mode,
        toggleColorMode,
        sidebarFontSize,
        increaseSidebarFontSize,
        decreaseSidebarFontSize,
    } = useThemeMode();
    // atoms
    // const selectedParameters = useRecoilValue<SelectedParametersType>(selectedParametersAtom);
    const getCurrentUser = useRecoilValue<UserType>(userAtom);
    const customerFeatures = useCustomerFeatures();
    const setSelectedParameters = useSetRecoilState<SelectedParametersType>(selectedParametersAtom);

    // cookies
    const [cookies, setCookies, removeCookies] = useCookies([
        "selectedParameters",
        "token",
        "oldToken",
        "oldSelectedParameters"
    ]);

    // functionalities states
    const [hideMenu, setHideMenu] = useState<boolean>(true);
    const [hideMenuEvents, setHideMenuEvents] = useState<boolean>(true);

    const [hasParameters, setHasParameters] = useState<boolean>(true);

    const [isOnline, setIsOnline] = useState<boolean>(true);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isToastVisible, setIsToastVisible] = useState(false);

    const [statusMessage, setStatusMessage] = useState<
        "warn" | "success" | "info" | "error" | undefined
    >("warn");

    const [loading, setLoading] = useState<boolean>(true);
    const [lastTemEventEmmited, setLastTemEventEmmited] = useState<
        Array<EventResponse>
    >([]);
    const [vehicleAlerts, setVehicleAlerts] = useState<VehicleAlertCustomerSummaryType>(
        vehicleAlertCustomerSummaryDefault
    );
    const [driverAlerts, setDriverAlerts] = useState<DriverAlertCustomerSummaryType>(
        driverAlertCustomerSummaryDefault
    );
    const [routeAlerts, setRouteAlerts] = useState<RouteDeviationAlert[]>([]);
    const [alertsError, setAlertsError] = useState<boolean>(false);

    const [showGeofences, setShowGeofences] = useState<boolean>(false);
    const [showInterestPoints, setShowInterestPoints] = useState<boolean>(false);
    const [showCarsFilter, setShowCarFilter] = useState<boolean>(false);
    const [showMapChanger, setShowMapChanger] = useState<boolean>(false);
    const [showMapSearch, setShowMapSearch] = useState<boolean>(false);
    const [isFixedMenu, setIsFixedMenu] = useState<boolean>(false);

    const [secretary, setSecretary] = useState<SecretarySimpleType>(secretaryDefault);
    // const [department, setDepartment] = useState<DepartmentSimpleType>(departmentDefault);

    const [secretariesList, setSecretariesList] = useState<Array<SecretarySimpleType>>([]);
    const [departmentsList, setDepartmentsList] = useState<Array<DepartmentSimpleType>>([]);

    // refs
    const toastRef = useRef<Toast>(null);
    const alertsInitializedRef = useRef<boolean>(false);
    const knownCriticalAlertsRef = useRef<Set<string>>(new Set());
    const alertScopeRef = useRef<string>("");
    const alertsRequestVersionRef = useRef<number>(0);
    const location = useLocation();
    const navigate = useNavigate();

    const introTour = useIntroTour({
        userId: getCurrentUser.id,
        enabled: customerFeatures?.useIntroTour === true
            && hasParameters
            && !loading
            && location.pathname === "/"
            && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER)
            // O admin entrando como cliente não precisa do tour.
            && localStorage.getItem("impersonating") !== "true",
        steps: introTourSteps,
        setMenuOpen: (open) => setHideMenu(!open),
    });
    const { running: introTourRunning, restart: restartIntroTour } = introTour;

    const userMenus = useMemo(
        () => [
            ...new Map(
                getCurrentUser.permissions
                    .flatMap((item) => item.optionItem.option)
                    .map((item: any) => [item.id, item])
            ).values(),
        ],
        [getCurrentUser.permissions]
    );

    const userMenusItens = useMemo(
        () =>
            getCurrentUser.permissions.flatMap((item) => {
                if (item.canView) return item.optionItem;
            }),
        [getCurrentUser.permissions]
    );

    const goToRoute = useCallback(
        async (path: string, state?: any) => {
            const hasConection: boolean = window.navigator.onLine;
            if (hasConection) {
                navigate(path, { state: state });
            } else {
                setIsOnline(false);
            }
        },
        [navigate]
    );

    const onSignOut = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const oldToken: string = cookies.oldToken;
        const oldParameters: SelectedParametersType = cookies.oldSelectedParameters;

        if (token) {
            try {
                if (oldToken) {
                    setCookies("token", oldToken);
                    setCookies("selectedParameters", oldParameters);

                    removeCookies("oldToken");
                    removeCookies("oldSelectedParameters");
                    localStorage.removeItem("impersonating");

                    goToRoute("/");
                } else {
                    try {
                        await logoutUser(getCurrentUser.id, token);
                        removeCookies("token");
                        removeCookies("selectedParameters");
                    } catch (error: any) {
                        console.log("Erro ao deslogar:", error.message);
                    }
                }
            } catch (error: any) {
                console.log(error.message);
            } finally {
                setTimeout(() => {
                    window.location.reload();
                }, 2500);
            }
        }
    }, [cookies.token, cookies.oldSelectedParameters, cookies.oldToken, setCookies, goToRoute, removeCookies, getCurrentUser.id]);

    const getSelectedParameters = useCallback(async () => {
        const parameters = cookies.selectedParameters;
        setLoading(true);

        if (!!parameters) {
            //setSelectedParameters(parameters);
            setHasParameters(true);
        } else {
            setHasParameters(false);
        }
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, [cookies.selectedParameters]);

    useEffect(() => {
        getSelectedParameters();
    }, [getSelectedParameters]);

    const getItemPermission = useCallback(
        (id: number) => {
            return getCurrentUser.permissions.find((permission) => {
                if (permission.optionItem.id === id) {
                    const { optionItem, ...rest } = permission;
                    return rest;
                }
            });
        },
        [getCurrentUser.permissions]
    );

    // Mostra o último evento ao abrir e depois busca todos os novos eventos,
    // em lotes limitados, para não perder entrada/saída de cerca entre consultas.
    useEffect(() => {
        if (!getCurrentUser.configs.customerSettings?.showEvents) {
            setLastTemEventEmmited([]);
            return;
        }

        const token = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType | undefined = cookies.selectedParameters;
        const customerId = currentParameters?.customer?.id ?? getCurrentUser.customer?.id;
        if (!token || !customerId || customerId < 1) {
            setLastTemEventEmmited([]);
            return;
        }

        let active = true;
        let polling = false;
        let initializing = false;
        let afterId: number | null = null;
        let lastPollAt = 0;
        const knownIds = new Set<number>();

        const poll = async () => {
            if (!active || polling || afterId === null) return;
            polling = true;
            lastPollAt = Date.now();
            const received: EventResponse[] = [];
            try {
                // Caso haja acúmulo, escoa até 300 eventos por consulta, sem carga ilimitada.
                for (let page = 0; page < 3 && active; page++) {
                    const result = await findRecentEventsByCustomer(token, customerId, afterId);
                    if (!active) break;
                    const batch = result.events;
                    if (batch.length > 0) {
                        afterId = Math.max(afterId, ...batch.map(event => event.id));
                        received.push(...batch.filter(event => !knownIds.has(event.id)));
                    }
                    if (!result.hasMore) {
                        afterId = Math.max(afterId, result.cursor);
                        break;
                    }
                }
            } catch (error) {
                console.log(error);
            }
            try {
                if (!active || received.length === 0) return;
                received.forEach(event => knownIds.add(event.id));
                if (knownIds.size > 500) {
                    for (const id of knownIds) {
                        knownIds.delete(id);
                        if (knownIds.size <= 250) break;
                    }
                }
                setLastTemEventEmmited(previous => [...previous, ...received]
                    .sort((a, b) => a.id - b.id).slice(-100));

                if (getCurrentUser.configs.customerSettings?.withSound) {
                    new Audio(eventSound).play().catch(() => undefined);
                }
                if (getCurrentUser.configs.customerSettings?.showDesktopEvents &&
                    document.hidden && "Notification" in window && Notification.permission === "granted") {
                    received.slice(-3).forEach(event => {
                        new Notification(eventHandlerMessage(event.name), {
                            body: event.eventDateTime,
                            badge: `Veículo ${event.vehicle.name}-${event.vehicle.vehiclePlate}`,
                            icon: "../../assets/files/brasion.png",
                        });
                    });
                } else if (getCurrentUser.configs.customerSettings?.showDesktopEvents &&
                    "Notification" in window && Notification.permission === "default") {
                    Notification.requestPermission();
                }
            } finally {
                polling = false;
            }
        };

        const initialize = async () => {
            if (!active || initializing) return;
            initializing = true;
            lastPollAt = Date.now();
            try {
                // Ponto inicial pela PK: evita revarrer eventos antigos de outros clientes.
                const baseline = await findRecentEventsByCustomer(token, customerId, -1);
                if (!active) return;
                afterId = baseline.cursor;
                const { data, status } = await findEventByCustomerAndDate(token, customerId);
                if (!active) return;
                if (status !== 204 && data?.id != null) {
                    knownIds.add(data.id);
                    setLastTemEventEmmited([data]);
                } else {
                    setLastTemEventEmmited([]);
                }
                await poll();
            } catch (error) {
                console.log(error);
            } finally {
                initializing = false;
            }
        };

        setLastTemEventEmmited([]);
        initialize();
        const tick = () => {
            if (Date.now() - lastPollAt < 30 * 60 * 1000) return;
            if (afterId === null) initialize(); else poll();
        };
        const intervalId = window.setInterval(tick, 30 * 60 * 1000);
        const onVisible = () => { if (document.visibilityState === "visible") tick(); };
        document.addEventListener("visibilitychange", onVisible);
        return () => {
            active = false;
            window.clearInterval(intervalId);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [
        cookies.token,
        cookies.selectedParameters,
        getCurrentUser.customer?.id,
        getCurrentUser.configs.customerSettings?.showEvents,
        getCurrentUser.configs.customerSettings?.showDesktopEvents,
        getCurrentUser.configs.customerSettings?.withSound,
    ]);

    const getAlerts = useCallback(async () => {
        if (getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.DRIVER)) return;

        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;
        const customerId = currentParameters?.customer?.id ?? getCurrentUser.customer?.id;
        const departmentId = currentParameters?.department?.id;
        const scope = `${customerId}:${departmentId ?? -1}`;
        const requestVersion = ++alertsRequestVersionRef.current;

        if (!token || !customerId || customerId < 1) {
            alertScopeRef.current = "";
            alertsInitializedRef.current = false;
            knownCriticalAlertsRef.current = new Set();
            setVehicleAlerts(vehicleAlertCustomerSummaryDefault);
            setDriverAlerts(driverAlertCustomerSummaryDefault);
            setRouteAlerts([]);
            setAlertsError(false);
            return;
        }

        if (alertScopeRef.current !== scope) {
            alertScopeRef.current = scope;
            alertsInitializedRef.current = false;
            knownCriticalAlertsRef.current = new Set();
            setVehicleAlerts(vehicleAlertCustomerSummaryDefault);
            setDriverAlerts(driverAlertCustomerSummaryDefault);
            setRouteAlerts([]);
            setAlertsError(false);
        }

        try {
            const canViewRoutes = getCurrentUser.permissions.some((permission) => permission.optionItem.id === Number(MENUS_ITENS.ROUTES) && permission.canView);
            const [vehicleResponse, driverResponse, routeResponse] = await Promise.all([
                findAllVehicleAlerts(token, customerId, departmentId).catch((error) => {
                    console.log(error);
                    return null;
                }),
                findAllDriverAlerts(token, customerId, departmentId).catch((error) => {
                    console.log(error);
                    return null;
                }),
                canViewRoutes && customerFeatures?.useCalculatedRoutes === true
                    ? routeApi.alerts(token, customerId, dayjs().subtract(7, "day").format("YYYY-MM-DD"), departmentId)
                        .catch((error) => { console.log(error); return null; })
                    : Promise.resolve([]),
            ]);
            if (alertsRequestVersionRef.current !== requestVersion) return;

            const vehicleSummary = vehicleResponse?.data as VehicleAlertCustomerSummaryType | undefined;
            const driverSummary = driverResponse?.data as DriverAlertCustomerSummaryType | undefined;
            const currentRouteAlerts = routeResponse as RouteDeviationAlert[] | null;
            const currentCriticalAlerts = new Map<string, string>();

            vehicleSummary?.vehicles.forEach((vehicle) => {
                vehicle.alerts
                    .filter((alert) => alert.severity === "CRITICAL")
                    .forEach((alert) => {
                        const key = [
                            "VEHICLE",
                            vehicle.vehicleId,
                            alert.code,
                            alert.sourceId,
                            alert.dueDate,
                            alert.dueOdometer,
                        ].join(":");
                        currentCriticalAlerts.set(
                            key,
                            `${vehicle.vehicleName} - ${vehicle.vehiclePlate}: ${alert.title}`
                        );
                    });
            });

            driverSummary?.alerts
                .filter((alert) => alert.severity === "CRITICAL")
                .forEach((alert) => {
                    const key = [
                        "DRIVER",
                        alert.driverId,
                        alert.code,
                        alert.dueDate,
                    ].join(":");
                    currentCriticalAlerts.set(key, `${alert.driverName}: ${alert.title}`);
                });

            currentRouteAlerts?.forEach((alert) => {
                currentCriticalAlerts.set(
                    `ROUTE:${alert.evaluationId}`,
                    `${alert.vehicleName} - ${alert.vehiclePlate}: desvio na rota ${alert.routeName}`
                );
            });

            if (alertsInitializedRef.current) {
                const newCriticalAlerts = [...currentCriticalAlerts.entries()]
                    .filter(([key]) => !knownCriticalAlertsRef.current.has(key));

                if (newCriticalAlerts.length > 0) {
                    toastRef.current?.show({
                        severity: "warn",
                        summary: "Novo alerta crítico",
                        detail: newCriticalAlerts.length === 1
                            ? newCriticalAlerts[0][1]
                            : `${newCriticalAlerts.length} novos alertas críticos requerem atenção.`,
                        life: 8000,
                    });
                }
            }

            const retainedKeys = [...knownCriticalAlertsRef.current].filter((key) =>
                (!vehicleSummary && key.startsWith("VEHICLE:")) ||
                (!driverSummary && key.startsWith("DRIVER:")) ||
                (currentRouteAlerts === null && key.startsWith("ROUTE:"))
            );
            knownCriticalAlertsRef.current = new Set([...retainedKeys, ...currentCriticalAlerts.keys()]);
            if (vehicleSummary && driverSummary) alertsInitializedRef.current = true;
            if (vehicleSummary) setVehicleAlerts(vehicleSummary);
            if (driverSummary) setDriverAlerts(driverSummary);
            if (currentRouteAlerts) setRouteAlerts(currentRouteAlerts);
            setAlertsError(!vehicleSummary || !driverSummary || currentRouteAlerts === null);
        } catch (error) {
            console.log(error);
            if (alertsRequestVersionRef.current === requestVersion) {
                setAlertsError(true);
            }
        }
    }, [
        cookies.selectedParameters,
        cookies.token,
        getCurrentUser.accessProfile.id,
        getCurrentUser.customer?.id,
        getCurrentUser.permissions,
        customerFeatures?.useCalculatedRoutes,
    ]);

    useEffect(() => {
        if (getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.DRIVER)) return;

        getAlerts();
        const intervalId = window.setInterval(getAlerts, 900000);
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") getAlerts();
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.clearInterval(intervalId);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            alertsRequestVersionRef.current += 1;
        };
    }, [getCurrentUser.accessProfile.id, getAlerts]);

    useEffect(() => {
        if (location.pathname !== "/" || getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.DRIVER)) return;

        const permissions = {
            tracker: getItemPermission(Number(MENUS_ITENS.TRACKING)),
            commands: getItemPermission(Number(MENUS_ITENS.COMMANDS)),
        };
        if (JSON.stringify(location.state) === JSON.stringify(permissions)) return;

        navigate("/", { state: permissions, replace: true });
        setHideMenu(true);
    }, [getItemPermission, getCurrentUser.accessProfile.id, location.pathname, location.state, navigate]);

    const IOSSwitch = useMemo(() => styled((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#65C466',
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#2ECA45',
                    }),
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
                ...theme.applyStyles('dark', {
                    opacity: 0.3,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    })), []);

    const renderSidebarItems = useCallback(
        (
            items: Array<{
                id: number;
                text: string;
                icon: JSX.Element;
                route: string;
            }>
        ) => {
            return items.map((item: any) => {
                const itemRoute = item.route.startsWith("/")
                    ? item.route
                    : `/${item.route}`;
                const isActive = itemRoute === "/"
                    ? window.location.pathname === "/"
                    : window.location.pathname.startsWith(itemRoute);

                const isDisabled = (!customerFeatures?.useVideoTelemetry && item.id === Number(MENUS_ITENS.VIDEO_TELEMETRY) && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER)) || (!customerFeatures?.useCheckList && item.id === Number(MENUS_ITENS.CHECK_LIST)) || (customerFeatures?.useWorkSchedules !== true && item.id === Number(MENUS_ITENS.WORK_SCHEDULES)) || (!getCurrentUser.configs.customerSettings?.useInterestPoint && item.id === Number(MENUS_ITENS.INTEREST_POINTS));

                return <ListItem
                    className="menuItem-option tw-my-0.5 tw-overflow-hidden tw-rounded-lg tw-transition-colors tw-duration-200 tw-ease-gtr-smooth"
                    key={item.text}
                    disablePadding
                    id={item.id}
                    {...(isDisabled ? {} : tourAnchor(menuTourId(item.id)))}
                    sx={{
                        color: "#ffff",
                        backgroundColor: isActive ? "#09414A" : "transparent",
                        borderRadius: 2,
                        boxShadow: isActive ? "inset 3px 0 0 #00B700" : "none",
                        transition: "background-color 200ms ease, box-shadow 200ms ease",
                        "&:hover": {
                            backgroundColor: isActive ? "#09414A" : "rgba(255, 255, 255, 0.10)",
                        },
                    }}
                >
                    <ListItemButton
                        className="tw-group !tw-min-h-10 !tw-rounded-lg !tw-px-3 !tw-py-2 tw-font-prometo tw-transition-[background-color,transform] tw-duration-200 tw-ease-gtr-smooth hover:tw-translate-x-0.5 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/70"
                        sx={{
                            color: "#ffff",
                            "&.Mui-disabled": { color: "#ffff", opacity: 0.45 },
                        }}
                        disabled={isDisabled}
                        onClick={() => {
                            if (item.route === "out") {
                                setLoading(true);
                                onSignOut();
                            } else {
                                const permissions = getItemPermission(item.id);
                                const state = item.id === Number(MENUS_ITENS.TRACKING)
                                    ? { tracker: permissions, commands: getItemPermission(Number(MENUS_ITENS.COMMANDS)) }
                                    : permissions;
                                goToRoute(item.route, state);
                                setHideMenu(true);
                            }
                        }}
                    >
                        <ListItemIcon
                            className="!tw-min-w-9 !tw-text-white tw-transition-transform tw-duration-200 group-hover:tw-scale-105"
                            sx={{
                                minWidth: 36,
                                color: "#ffff",
                                "& .MuiSvgIcon-root": { color: "#ffff", fill: "currentColor" },
                            }}
                        >
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={item.text}
                            primaryTypographyProps={{
                                color: "#ffff",
                                fontFamily: "Prometo",
                                fontSize: 14,
                                fontWeight: isActive ? 700 : 400,
                            }}
                        />
                    </ListItemButton>
                </ListItem>
            });
        },
        [goToRoute, onSignOut, getItemPermission, hideMenu, customerFeatures?.useVideoTelemetry, customerFeatures?.useCheckList, customerFeatures?.useWorkSchedules, getCurrentUser.configs.customerSettings?.useInterestPoint, getCurrentUser.accessProfile.id]
    );

    const saveSelectedParameters = useCallback(async (department: DepartmentSimpleType | null) => {
        const { image, ...rest } = getCurrentUser.customer;

        const data: SelectedParametersType = {
            userId: getCurrentUser.id,
            customer: rest,
            secretary: secretary,
            department: department ? department : {
                id: -1,
                name: "",
                reducedName: "",
                cnpj: "",
                customerId: -1,
                secretaryId: -1
            },
            isViewingAll: department ? false : true
        };

        if ((!data.secretary.name || !data.department.name) && !getCurrentUser.configs.isDriver) {
            const message = "A seleção de parâmetros é obrigatória, tente novamente.";
            setFieldsIsValid(false);
            setTextValidation(message);
            return;
        }
        setCookies("selectedParameters", data, {
            expires: new Date(dayjs().add(7, "days").toLocaleString()),
        });
        setSelectedParameters(data);
        setHasParameters(true)
    }, [
        getCurrentUser.id,
        getCurrentUser.configs.isDriver,
        getCurrentUser.customer,
        secretary,
        setCookies,
        setSelectedParameters
    ]);

    const getSecretariesList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;
        try {
            const response = await userFindAllSecretariesListResponse(
                token,
                userId
            );
            if (response.data.length > 0) {
                setSecretary(response.data[0]);
            }
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, getCurrentUser.id]);

    const getDepartmentsList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;

        try {
            const response =
                await userFindAllDepartmentsListResponse(
                    token,
                    userId,
                    secretary?.id
                );

            if (response.data.length > 0) {
                saveSelectedParameters(response.data[0]);
            }
        } catch (error) {
            console.log(error);
            setDepartmentsList([]);
        }
    }, [cookies.token, getCurrentUser.id, secretary.id, saveSelectedParameters]);

    useEffect(() => {
        if (secretary?.name) {
            getDepartmentsList();
        }
    }, [getDepartmentsList, secretary?.name]);

    const verifyCustomerType = useCallback(() => {
        if (getCurrentUser.customer?.useCpf && getCurrentUser.customer?.cpf) {
            getSecretariesList();
        }

        if (getCurrentUser.configs?.isDriver) {
            saveSelectedParameters(null);
        }
    }, [saveSelectedParameters, getCurrentUser.customer?.useCpf, getCurrentUser.customer?.cpf, getSecretariesList, getCurrentUser.configs?.isDriver]);

    useEffect(() => {
        verifyCustomerType();
    }, [verifyCustomerType]);

    const renderSidebarWithPermissionsItems = useCallback(
        (
            menus: Array<{
                id: number;
                text: string;
                icon: JSX.Element;
            }>,
            items: Array<{
                id: number;
                text: string;
                menuId: number;
                icon: JSX.Element;
                route: string;
            }>
        ) => {
            const renderMenuList = menus.filter((menu) => {
                return userMenus.find((it) => {
                    if (menu.id === it.id) {
                        return menu;
                    }
                });
            });

            const renderMenuItens = items.filter((item) => {
                return userMenusItens.find((it) => {
                    if ((item.menuId === it?.option.id && item.id === it.id) || (item.id === Number(MENUS_ITENS.HELP_DESK) && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER))) {
                        return item;
                    }
                });
            }).filter((item) => {
                const isAccessItem = item.id === Number(MENUS_ITENS.ACCESSES);
                const shouldIgnore = isAccessItem && getCurrentUser.customer?.useCpf;
                return !shouldIgnore;
            }).filter((item) => {
                const isAccessItem = item.id === Number(MENUS_ITENS.CHECK_LIST);
                const shouldIgnore = isAccessItem && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER);
                return !shouldIgnore;
            });

            return (
                <Box
                    className="menu-options tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-px-2 tw-pb-16 tw-font-prometo"
                    sx={{
                        minHeight: 0,
                        flex: 1,
                        overflowY: "auto",
                        px: 1,
                        pb: 8,
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        "&::-webkit-scrollbar": { display: "none" },
                    }}
                >
                    {renderMenuList.map((menu, index) => (
                        <Box key={index} className="tw-py-1">
                            {renderMenuItens.some((items) => items.menuId === menu.id) && (
                                <Box
                                    className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-white/90"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        px: 1.5,
                                        py: 1,
                                        color: "rgba(255, 255, 255, 0.90)",
                                        "& .MuiSvgIcon-root": { color: "#ffff" },
                                    }}
                                >
                                    {menu.icon}
                                    <Typography
                                        className="!tw-font-prometo !tw-text-xs !tw-font-bold !tw-uppercase !tw-tracking-wider"
                                        sx={{ color: "#ffff", fontSize: 12, fontWeight: 700, letterSpacing: "0.08em" }}
                                    >
                                        {menu.text}
                                    </Typography>
                                </Box>
                            )}
                            <Divider className="!tw-border-white/20" sx={{ borderColor: "rgba(255, 255, 255, 0.20)" }} />
                            {renderSidebarItems(
                                renderMenuItens.filter((items) => items.menuId === menu.id)
                            )}
                        </Box>
                    ))}
                    {/*<Divider color="white" />*/}
                    {/*<List>{renderSidebarItems(footerItems)}</List>*/}
                </Box>
            );
        },
        [renderSidebarItems, userMenus, userMenusItens, getCurrentUser.customer?.useCpf, getCurrentUser.accessProfile.id]
    );

    const totalAlerts = vehicleAlerts.total + driverAlerts.total + routeAlerts.length;
    const criticalAlerts = vehicleAlerts.critical + driverAlerts.critical + routeAlerts.length;
    const warningAlerts = vehicleAlerts.warning + driverAlerts.warning;

    const renderMapOptions = useMemo(() => {
        return (
            <Box>
                {!isFixedMenu && (
                    <Box
                        className="tw-shadow-lg tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                        sx={{
                            position: "absolute",
                            zIndex: 99999,
                            left: 10,
                            top: 10,
                            border: "1px solid rgba(255, 255, 255, 0.16)",
                            borderRadius: 2.5,
                            backgroundImage: "linear-gradient(135deg, rgba(0, 108, 119, 0.96), rgba(9, 65, 74, 0.96))",
                            boxShadow: "0 8px 24px rgba(9, 65, 74, 0.22)",
                            visibility: hideMenuEvents ? "visible" : "hidden",
                            opacity: hideMenuEvents ? 1 : 0,
                            transform: hideMenuEvents ? "translateY(0)" : "translateY(-6px)",
                            pointerEvents: hideMenuEvents ? "auto" : "none",
                        }}
                    >
                        <Tooltip title="Ocultar ou mostrar menu" arrow placement="right">
                            <IconButton
                                {...tourAnchor("menu-toggle")}
                                aria-label="Ocultar ou mostrar menu"
                                className="!tw-h-11 !tw-w-11 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                onClick={() => {
                                    setHideMenu(!hideMenu);
                                    setHideMenuEvents(true);
                                }}
                            >
                                {hideMenu ? (
                                    <MenuOutlined style={{ color: "#ffff" }} />
                                ) : (
                                    <MenuOpenOutlined style={{ color: "#ffff" }} />
                                )}
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}

                {getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER) && (
                    <Box
                        className="event-drawer-button tw-shadow-lg tw-backdrop-blur-md"
                        sx={{
                            position: "absolute",
                            zIndex: 99999,
                            right: 10,
                            top: 10,
                            border: "1px solid rgba(255, 255, 255, 0.16)",
                            borderRadius: 2.5,
                            backgroundImage: "linear-gradient(135deg, rgba(0, 108, 119, 0.96), rgba(9, 65, 74, 0.96))",
                            boxShadow: "0 8px 24px rgba(9, 65, 74, 0.22)",
                        }}
                    >
                        <Tooltip title="Visualizar alertas e eventos" arrow placement="left">
                            <IconButton
                                {...tourAnchor("map-alerts")}
                                aria-label="Visualizar alertas e eventos"
                                className="!tw-h-11 !tw-w-11 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                onClick={() => {
                                    if (isFixedMenu) {
                                        setHideMenuEvents(!hideMenuEvents);
                                    } else {
                                        setHideMenuEvents(!hideMenuEvents);
                                        setHideMenu(true);
                                    }
                                }}
                            >
                                <Badge
                                    badgeContent={totalAlerts}
                                    color={criticalAlerts > 0 ? "error" : "warning"}
                                    max={99}
                                    sx={{
                                        "& .MuiBadge-badge": {
                                            backgroundColor: criticalAlerts > 0 ? "#d32f2f" : "#ed6c02",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            boxShadow: "0 0 0 2px rgb(0, 63, 74)",
                                        },
                                    }}
                                >
                                    {hideMenuEvents ? (
                                        <NotificationsActiveOutlined
                                            sx={{ color: criticalAlerts > 0 ? "#ff5252" : warningAlerts > 0 ? "#ffb74d" : "#ffff" }}
                                        />
                                    ) : (
                                        <NotificationsNoneOutlined
                                            sx={{ color: criticalAlerts > 0 ? "#ff5252" : warningAlerts > 0 ? "#ffb74d" : "#ffff" }}
                                        />
                                    )}
                                </Badge>
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}

                <Box
                    aria-hidden={!hideMenuEvents}
                    className="tw-shadow-xl tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    sx={{
                        position: "absolute",
                        zIndex: 99999,
                        right: 10,
                        top: 65,
                        display: location.pathname.endsWith("/") && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER) ? "flex" : "none",
                        flexDirection: "column",
                        gap: 0.5,
                        padding: 0.5,
                        border: "1px solid rgba(255, 255, 255, 0.16)",
                        borderRadius: 3,
                        backgroundImage: "linear-gradient(180deg, rgba(0, 108, 119, 0.96), rgba(9, 65, 74, 0.96))",
                        boxShadow: "0 12px 32px rgba(9, 65, 74, 0.24)",
                        visibility: hideMenuEvents ? "visible" : "hidden",
                        opacity: hideMenuEvents ? 1 : 0,
                        transform: hideMenuEvents ? "translateX(0)" : "translateX(8px)",
                        pointerEvents: hideMenuEvents ? "auto" : "none",
                        "& .MuiIconButton-root": {
                            width: 40,
                            height: 40,
                            color: "#fff",
                            borderRadius: 2,
                            transition: "background-color 180ms ease, color 180ms ease, transform 180ms ease",
                        },
                        "& .MuiIconButton-root:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.13)",
                            transform: "translateX(-2px)",
                        },
                    }}
                >
                    <Tooltip title="Mostrar cercas virtuais" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-geofences")}
                            aria-label="Mostrar cercas virtuais"
                            onClick={() => {
                                setShowGeofences(!showGeofences);
                            }}
                        >
                            <ShareLocationOutlined
                                sx={{
                                    color: "#ffff",
                                    fill: showGeofences ? "#00b700" : "#ffff",
                                }}
                            />
                        </IconButton>
                    </Tooltip>

                    {getCurrentUser.configs.customerSettings?.useInterestPoint && (
                        <Tooltip title="Mostrar pontos de interesse" arrow placement="left">
                            <IconButton
                                {...tourAnchor("map-interest-points")}
                                aria-label="Mostrar pontos de interesse"
                                onClick={() => {
                                    setShowInterestPoints(!showInterestPoints);
                                }}
                            >
                                <PlaceOutlined sx={{ color: showInterestPoints ? "#00b700" : "#ffff" }} />
                            </IconButton>
                        </Tooltip>
                    )}

                    <Tooltip title="Filtrar veículos no mapa" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-filter")}
                            aria-label="Filtrar veículos no mapa"
                            onClick={() => {
                                setShowCarFilter(!showCarsFilter);
                            }}
                        >
                            <TuneOutlined sx={{ color: showCarsFilter ? "#00b700" : "#ffff" }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Selecionar mapa" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-layers")}
                            aria-label="Selecionar mapa"
                            onClick={() => {
                                setShowMapChanger(!showMapChanger);
                            }}
                        >
                            <LayersOutlined sx={{ color: showMapChanger ? "#00b700" : "#ffff" }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Pesquisar endereço" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-search")}
                            aria-label="Pesquisar endereço"
                            onClick={() => {
                                setShowMapSearch(!showMapSearch);
                            }}
                        >
                            <SearchOutlined sx={{ color: showMapSearch ? "#00b700" : "#ffff" }} />
                        </IconButton>
                    </Tooltip>

                    {getCurrentUser.configs.canShareTransparencyPortal && <TransparencyPortalLinkButton />}

                    {customerFeatures?.useIntroTour === true && (
                        <Tooltip title="Ver o tour de introdução" arrow placement="left">
                            <IconButton
                                {...tourAnchor("map-tour-replay")}
                                aria-label="Ver o tour de introdução"
                                onClick={restartIntroTour}
                            >
                                <HelpOutlineOutlined sx={{ color: "#ffff" }} />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </Box>
        );
    }, [
        showGeofences,
        showInterestPoints,
        getCurrentUser.configs.customerSettings?.useInterestPoint,
        hideMenuEvents,
        hideMenu,
        getCurrentUser.accessProfile.id,
        getCurrentUser.configs.canShareTransparencyPortal,
        totalAlerts,
        criticalAlerts,
        warningAlerts,
        showCarsFilter,
        showMapChanger,
        showMapSearch,
        isFixedMenu,
        location.pathname,
        customerFeatures?.useIntroTour,
        restartIntroTour
    ]);

    const template = useMemo(() => {
        return (
            <>
                {renderMapOptions}
                <Drawer
                    ModalProps={{}}
                    className="event-drawer"
                    anchor={"right"}
                    open={!hideMenuEvents}
                    onClose={() => setHideMenuEvents(!hideMenuEvents)}
                    PaperProps={{
                        className:
                            "!tw-w-[calc(100vw-1.5rem)] sm:!tw-w-80 !tw-overflow-hidden !tw-bg-gtr-sidebar !tw-text-white tw-shadow-gtr-sidebar tw-transition-transform tw-duration-300 tw-ease-gtr-smooth dark:!tw-bg-slate-950",
                    }}
                    sx={{
                        width: { xs: "calc(100vw - 24px)", sm: 320 },
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: { xs: "calc(100vw - 24px)", sm: 320 },
                            color: "#ffff",
                            backgroundImage: mode === "dark"
                                ? "linear-gradient(to bottom, #0f172a, #020617)"
                                : "linear-gradient(to right, #006C77 , #09414A)",
                            boxSizing: "border-box",
                            overflow: "hidden",
                        },
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        }}
                    >
                        <Toolbar
                            className="!tw-min-h-16 !tw-flex-none !tw-border-b !tw-border-white/20 !tw-px-4"
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexShrink: 0,
                                borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                            }}
                        >
                            <Box className="tw-flex tw-items-center tw-gap-2">
                                <NotificationsActiveOutlined />
                                <Typography variant="h6" component="h2" sx={{ fontFamily: "Prometo", fontWeight: 700 }}>
                                    Alertas e eventos
                                </Typography>
                            </Box>
                            <Box className="tw-flex tw-h-8 tw-min-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-white/10 tw-px-2">
                                <Typography variant="caption" sx={{ fontFamily: "Prometo", fontWeight: 700 }}>{totalAlerts}</Typography>
                            </Box>
                        </Toolbar>
                        <Box
                            className="event-drawer-content tw-scroll-smooth tw-bg-slate-100/95 dark:tw-bg-slate-950"
                            sx={{
                                padding: 1.5,
                                flex: 1,
                                minHeight: 0,
                                overflowY: "auto",
                                display: "flex",
                                flexDirection: "column",
                                gap: 1.5,
                                backgroundColor: mode === "dark" ? "#020617" : "rgba(241,245,249,0.96)",
                                scrollbarWidth: "thin",
                                scrollbarColor: "#006C77 transparent",
                            }}
                        >
                            {/*<Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                                Manutenções e checklists
                            </Typography>*/}
                            {alertsError && (
                                <Typography className="tw-rounded-xl tw-border tw-border-red-100 tw-bg-red-50 tw-p-3 tw-text-red-700" variant="body2" sx={{ textAlign: "center", padding: 1.5 }}>
                                    Não foi possível atualizar todos os alertas. A consulta será repetida automaticamente.
                                </Typography>
                            )}
                            {!alertsError && totalAlerts === 0 && (
                                <Typography className="tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-text-slate-500" variant="body2" sx={{ textAlign: "center", padding: 2 }}>
                                    Nenhum alerta pendente.
                                </Typography>
                            )}

                            {/*getCurrentUser.configs.customerSettings?.showEvents && (
                                <>
                                    <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.3)" }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", padding: 2 }}>
                                        Eventos de rastreamento
                                    </Typography>
                                </>
                            )*/}

                            {vehicleAlerts.total > 0 && (
                                <>
                                    <Typography className="tw-px-1 tw-text-slate-700" variant="subtitle2" sx={{ fontWeight: 700 }}>
                                        Veículos
                                    </Typography>
                                    {vehicleAlerts.vehicles.flatMap((vehicle) =>
                                        vehicle.alerts.map((alert) => (
                                            <VehicleAlertCard
                                                key={`${vehicle.vehicleId}-${alert.code}-${alert.sourceId}-${alert.dueDate}-${alert.dueOdometer}`}
                                                vehicle={vehicle}
                                                alert={alert}
                                            />
                                        ))
                                    )}
                                </>
                            )}

                            {driverAlerts.total > 0 && (
                                <>
                                    {vehicleAlerts.total > 0 && (
                                        <Divider sx={{ borderColor: "rgba(15, 23, 42, 0.10)", marginY: 0.5 }} />
                                    )}
                                    <Typography className="tw-px-1 tw-text-slate-700" variant="subtitle2" sx={{ fontWeight: 700 }}>
                                        Motoristas
                                    </Typography>
                                    {driverAlerts.alerts.map((alert) => (
                                        <DriverAlertCard key={alert.code} alert={alert} />
                                    ))}
                                </>
                            )}

                            {routeAlerts.length > 0 && (
                                <>
                                    <Divider sx={{ borderColor: "rgba(15, 23, 42, 0.10)", marginY: 0.5 }} />
                                    <Typography className="tw-px-1 tw-text-slate-700" variant="subtitle2" sx={{ fontWeight: 700 }}>
                                        Desvios de rota
                                    </Typography>
                                    {routeAlerts.map((alert) => <RouteDeviationAlertCard key={alert.evaluationId} alert={alert} />)}
                                </>
                            )}

                            {getCurrentUser.configs.customerSettings?.showEvents && lastTemEventEmmited.length > 0 && (
                                <>
                                    <Divider sx={{ borderColor: "rgba(15, 23, 42, 0.10)", marginY: 0.5 }} />
                                    <Typography className="tw-px-1 tw-text-slate-700" variant="subtitle2" sx={{ fontWeight: 700 }}>
                                        Eventos de rastreamento
                                    </Typography>
                                    {lastTemEventEmmited.map((event) => (
                                        <TrackingEventAlertCard key={event.id} event={event} />
                                    ))}
                                </>
                            )}
                        </Box>
                    </Box>
                </Drawer>

                <Drawer
                    anchor={"left"}
                    open={isFixedMenu ? true : !hideMenu}
                    // O foco preso no menu brigaria com o foco do balão do tour.
                    ModalProps={{ disableEnforceFocus: introTourRunning }}
                    variant={isFixedMenu ? "persistent" : "temporary"}
                    onClose={() => setHideMenu(!hideMenu)}
                    hideBackdrop={isFixedMenu ? true : false}
                    className="menu-drawer"
                    PaperProps={{
                        className:
                            "!tw-w-[86vw] !tw-max-w-[300px] sm:!tw-w-[280px] !tw-overflow-hidden !tw-bg-gtr-sidebar !tw-text-white tw-shadow-gtr-sidebar tw-transition-transform tw-duration-300 tw-ease-gtr-smooth",
                    }}
                    sx={{
                        width: { xs: "min(86vw, 300px)", sm: 280 },
                        flexShrink: "initial",
                        "& .MuiDrawer-paper": {
                            width: { xs: "min(86vw, 300px)", sm: 280 },
                            color: "#ffff",
                            backgroundImage: "linear-gradient(to right, #006C77 , #09414A)",
                            boxShadow: "0 12px 36px rgba(0, 0, 0, 0.22)",
                            boxSizing: "border-box",
                            overflow: "hidden",
                            borderRight: "none",
                        },
                    }}
                >
                    <Box
                        component="aside"
                        className="gtr-sidebar tw-relative tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden tw-font-prometo"
                        sx={{
                            "--gtr-sidebar-font-size": `${sidebarFontSize}px`,
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "100%",
                            overflow: "hidden",
                            fontFamily: "Prometo",
                        }}
                    >
                        <Toolbar
                            className="!tw-flex !tw-min-h-0 !tw-w-full !tw-flex-none !tw-flex-col !tw-items-stretch !tw-p-0"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "stretch",
                                width: "100%",
                                minHeight: 0,
                                padding: 0,
                                backgroundImage: "linear-gradient(to right, #006C77 , #09414A)",
                            }}
                        >
                            <Box
                                className="tw-relative tw-flex tw-min-h-28 tw-items-center tw-justify-center tw-overflow-hidden tw-py-4"
                                sx={{
                                    position: "relative",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: 112,
                                    paddingY: 2,
                                    overflow: "hidden",
                                }}
                            >
                                <Box
                                    aria-hidden="true"
                                    className="tw-absolute tw-h-24 tw-w-24 tw-rounded-full tw-bg-cover tw-bg-center tw-opacity-70 tw-blur-[1px]"
                                    sx={{
                                        position: "absolute",
                                        width: 96,
                                        height: 96,
                                        borderRadius: "50%",
                                        backgroundImage: `url(${require("../../assets/files/maps-image.png")})`,
                                        backgroundPosition: "center",
                                        backgroundSize: "cover",
                                        filter: "blur(1px)",
                                        opacity: 0.7,
                                    }}
                                />
                                <Box
                                    className="tw-relative tw-flex tw-h-20 tw-w-20 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-border-0 tw-bg-gtr-teal-dark tw-shadow-xl"
                                    sx={{
                                        position: "relative",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: 80,
                                        height: 80,
                                        overflow: "hidden",
                                        borderRadius: "50%",
                                        border: "none",
                                        backgroundColor: "#09414A",
                                        boxShadow: "0 10px 28px rgba(0, 0, 0, 0.24)",
                                    }}
                                >
                                    <AccountCircleOutlined sx={{ width: 64, height: 64, color: "#dbdbdb" }} />
                                    {!!getCurrentUser.customer.image && (
                                        <Box
                                            component="img"
                                            src={getCurrentUser.customer.image}
                                            alt="Imagem do usuário"
                                            onError={(event: any) => {
                                                event.currentTarget.style.display = "none";
                                            }}
                                            sx={{
                                                position: "absolute",
                                                inset: 0,
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    )}
                                </Box>
                            </Box>

                            <Box
                                className="!tw-w-[86vw] !tw-max-w-[300px] sm:!tw-w-[280px] tw-bg-gtr-green tw-px-4 tw-py-3 tw-shadow-[0_-8px_24px_rgba(0,0,0,0.08)]"
                                sx={{
                                    width: { xs: "min(86vw, 300px)", sm: "280px" },
                                    minWidth: { xs: "min(86vw, 300px)", sm: "280px" },
                                    maxWidth: { xs: "min(86vw, 300px)", sm: "280px" },
                                    alignSelf: "stretch",
                                    flexShrink: 0,
                                    margin: 0,
                                    boxSizing: "border-box",
                                    paddingX: 2,
                                    paddingY: 1.5,
                                    backgroundColor: "#00B700",
                                    boxShadow: "0 -8px 24px rgba(0, 0, 0, 0.08)",
                                }}
                            >
                                <Box
                                    className="header-title"
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontFamily: "Prometo",
                                    }}
                                >
                                    <Box
                                        className="element"
                                        style={{
                                            lineBreak: "anywhere",
                                            color: "#ffff",
                                            display: "table-column-group",
                                            alignSelf: "center",
                                            justifySelf: "center",
                                            width: "100%"
                                        }}
                                    >
                                        <Typography variant="subtitle1" sx={{ color: "#ffff", textAlign: "center", fontWeight: 700, lineHeight: 1.25, overflowWrap: "anywhere" }}>{!getCurrentUser?.customer?.useCpf ? getCurrentUser?.customer?.reducedName : getCurrentUser?.customer?.name}</Typography>
                                        <Divider sx={{ marginY: 0.5, borderColor: "rgba(255, 255, 255, 0.45)" }} />
                                        {!getCurrentUser?.customer?.useCpf && <>
                                            <Typography variant="subtitle2" sx={{ color: "#ffff", textAlign: "center" }}>{cookies.selectedParameters?.secretary?.reducedName}</Typography>
                                            <Divider sx={{ marginY: 0.5, borderColor: "rgba(255, 255, 255, 0.45)" }} />
                                            <Typography variant="subtitle2" sx={{ color: "#ffff", textAlign: "center" }}>{cookies.selectedParameters?.department?.reducedName}</Typography></>
                                        }
                                    </Box>
                                </Box>
                                <Box
                                    className="header-actions"
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        alignContent: "center",
                                        fontFamily: "Prometo",
                                        marginTop: 0.5,
                                    }}
                                >
                                    {(!getCurrentUser?.customer?.useCpf && !getCurrentUser.configs.isDriver) && (
                                        <Tooltip title="Selecionar parâmetros" arrow placement="top">
                                            <IconButton
                                                aria-label="Selecionar parâmetros"
                                                className="!tw-mx-0.5 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                                onClick={() => {
                                                    removeCookies("selectedParameters");
                                                    goToRoute("/");
                                                }}
                                            >
                                                <ManageAccountsOutlined style={{ color: "#ffff" }} />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <Tooltip title="Perfil" arrow placement="top">
                                        <IconButton
                                            aria-label="Abrir perfil"
                                            className="!tw-mx-0.5 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                            onClick={() => {
                                                goToRoute("/user-profile");
                                            }}
                                        >
                                            <PersonOutlineOutlined style={{ color: "#ffff" }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={mode === "dark" ? "Usar tema claro" : "Usar tema escuro"} arrow placement="top">
                                        <IconButton
                                            aria-label={mode === "dark" ? "Usar tema claro" : "Usar tema escuro"}
                                            className="!tw-mx-0.5 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                            onClick={toggleColorMode}
                                        >
                                            {mode === "dark" ? (
                                                <WbSunnyOutlined style={{ color: "#ffff" }} />
                                            ) : (
                                                <DarkModeOutlined style={{ color: "#ffff" }} />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                    {!getCurrentUser.configs.isDriver && (
                                        <Tooltip title="Sair" arrow placement="top">
                                            <IconButton
                                                aria-label="Sair"
                                                className="!tw-mx-0.5 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                                onClick={() => {
                                                    onSignOut();
                                                }}
                                            >
                                                <ExitToAppOutlined style={{ color: "#ffff" }} />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Box>
                                <Box
                                    role="group"
                                    aria-label="Tamanho da fonte do menu"
                                    className="tw-mt-1 tw-flex tw-items-center tw-justify-center tw-gap-1"
                                >
                                    <Tooltip title="Diminuir fonte do menu" arrow placement="bottom">
                                        <span>
                                            <IconButton
                                                aria-label="Diminuir fonte do menu"
                                                disabled={sidebarFontSize <= 12}
                                                onClick={decreaseSidebarFontSize}
                                                className="!tw-h-7 !tw-w-7 hover:!tw-bg-white/15"
                                                sx={{ color: "#fff", "&.Mui-disabled": { color: "rgba(255,255,255,0.42)" } }}
                                            >
                                                <span className="gtr-sidebar-font-control" aria-hidden="true">A−</span>
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Typography component="span" aria-live="polite" sx={{ color: "#fff", minWidth: 34, textAlign: "center", fontWeight: 700 }}>
                                        {sidebarFontSize}px
                                    </Typography>
                                    <Tooltip title="Aumentar fonte do menu" arrow placement="bottom">
                                        <span>
                                            <IconButton
                                                aria-label="Aumentar fonte do menu"
                                                disabled={sidebarFontSize >= 16}
                                                onClick={increaseSidebarFontSize}
                                                className="!tw-h-7 !tw-w-7 hover:!tw-bg-white/15"
                                                sx={{ color: "#fff", "&.Mui-disabled": { color: "rgba(255,255,255,0.42)" } }}
                                            >
                                                <span className="gtr-sidebar-font-control" aria-hidden="true">A+</span>
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Toolbar>
                        {renderSidebarWithPermissionsItems(sidebarMenus, [
                            ...sidebarConfigsItems,
                            ...sidebarRecordsItems,
                        ])}
                        {/*<Box
                            className="menu-footer"
                            style={{
                                position: "absolute",
                                bottom: 0,
                                right: 100,
                                borderRadius: 100,
                                margin: 10,
                            }}
                        >
                            <CardMedia
                                style={{
                                    height: 50,
                                    width: 50,
                                    objectFit: "contain",
                                }}
                                component="img"
                                alt="Imagem"
                                image={require("../../assets/files/gtf-white.png")}
                            />
                        </Box>*/}

                        <Box
                            className="menu-footer tw-absolute tw-bottom-3 tw-right-3 tw-z-10 tw-rounded-full tw-bg-black/10 tw-p-1 tw-backdrop-blur-sm"
                            sx={{
                                position: "absolute",
                                right: 12,
                                bottom: 12,
                                zIndex: 10,
                                padding: 0.5,
                                borderRadius: "50%",
                                backgroundColor: "rgba(0, 0, 0, 0.10)",
                                backdropFilter: "blur(4px)",
                            }}
                        >
                            <Tooltip title="Fixar o menu" arrow placement="left">
                                <IOSSwitch
                                    checked={isFixedMenu}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setIsFixedMenu(checked);
                                    }}
                                    inputProps={{ 'aria-label': 'Fixar menu' }}
                                />
                            </Tooltip>
                        </Box>
                    </Box>
                </Drawer>
                <Box
                    style={{
                        width: "100vw",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box>
                        <Toast
                            ref={toastRef}
                            position="center"
                            style={{ position: "absolute" }}
                            onShow={() => {
                                setTimeout(() => {
                                    setTextValidation("");
                                    setStatusMessage("warn");
                                    setIsToastVisible(false);
                                }, 3500);
                            }}
                        />
                        {getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER) && <PrivateRoutes
                            isHiddenMenu={hideMenu || hideMenuEvents}
                            isFixedMenu={isFixedMenu}
                            isMenuOverlayOpen={!isFixedMenu && !hideMenu}
                            customerFeatures={customerFeatures}
                            showGeofences={showGeofences}
                            showInterestPoints={showInterestPoints}
                            showCarsFilter={showCarsFilter}
                            showMapChanger={showMapChanger}
                            showMapSearch={showMapSearch}
                            filterActions={[
                                {
                                    name: "showCarsFilter",
                                    action: (value: boolean) => setShowCarFilter(value),
                                },
                                {
                                    name: "showMapChanger",
                                    action: (value: boolean) => setShowMapChanger(value),
                                },
                                {
                                    name: "showMapSearch",
                                    action: (value: boolean) => setShowMapSearch(value),
                                },
                            ]}
                        />
                        }

                        {getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.DRIVER) &&
                            <PrivateDriverRoutes
                                isHiddenMenu={hideMenu || hideMenuEvents}
                            />
                        }
                    </Box>
                </Box>
            </>
        );
    }, [
        goToRoute,
        onSignOut,
        removeCookies,
        showCarsFilter,
        showMapChanger,
        showMapSearch,
        getCurrentUser.customer.image,
        renderMapOptions,
        showGeofences,
        getCurrentUser.configs.isDriver,
        cookies.selectedParameters?.department?.reducedName,
        cookies.selectedParameters?.secretary?.reducedName,
        getCurrentUser.accessProfile.id,
        getCurrentUser.customer?.name,
        cookies?.selectedParameters?.department?.id,
        lastTemEventEmmited,
        vehicleAlerts,
        driverAlerts,
        routeAlerts,
        totalAlerts,
        alertsError,
        getCurrentUser.configs.customerSettings?.showEvents,
        hideMenuEvents,
        getCurrentUser?.customer?.reducedName,
        getCurrentUser.customer?.useCpf,
        renderSidebarWithPermissionsItems,
        hideMenu,
        isFixedMenu,
        IOSSwitch,
        mode,
        toggleColorMode,
        sidebarFontSize,
        increaseSidebarFontSize,
        decreaseSidebarFontSize,
        customerFeatures,
        introTourRunning
    ]);

    return !!hasParameters && !loading ? (
        <>
            {template}
            {introTour.tour}
        </>
    ) : (
        <>
            {!loading ? (
                <SelectParametersModal
                    onSend={() => {
                        setHasParameters(true);
                    }}
                    onClose={() => { }}
                    handleChange={() => { }}
                    fieldValue=""
                    isVisible={true}
                    loading={loading}
                />
            ) : (
                <Box
                    style={{
                        marginTop: 2,
                        borderRadius: 5,
                        fontFamily: "Prometo",
                        height: 650,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div className="tracker-loading-main">
                        <div className="ld-tracker ld-tracker-main">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </Box>
            )}
        </>
    );
};

export default PrivateApp;
